import {SimpleStore} from "../simplestore";
import router from "../router/router";

export default class ErrorHelper {

  static handleError(app, response) {
    if (response.status && response.status === "ERROR") {
      SimpleStore.addFlashMessage(response.message, 'error');
      return true;
    } else if (response.status && response.status === "UNAUTHORIZED") {
      SimpleStore.addFlashMessage(response.message, 'error');
      router.push({ name: 'Login'});
      return true;
    }
    return false;
  }

}